import React from 'react';
import styles from './tieMatchUp.module.scss';
import { ReactComponent as Tick } from '../../static/icon-tick.svg';
import { getEnvConfig } from '../../config/config';

interface TieMatchUpProps {
  data?: any;
  number?: number;
  homeTeamNumber?: number;
  homeTeamId?: string;
  awayTeamId?: string;
}

interface SideProps {
  side?: any;
  status?: any;
  teamId?: string;
}

interface ParticipantsProps {
  participants?: any;
  teamId?: string;
}

interface StatusProps {
  side: any;
  status?: any;
}

const Participants: React.FC<ParticipantsProps> = ({ participants, teamId }) => {
  const teamUrl = getEnvConfig().teamUrl;

  const renderParticipants = () => {
    if (participants.length === 0) {
      return <span>TBD</span>;
    }

    return participants.map((obj: any, number: number) => (
      <span key={number}>
        <a href={`${teamUrl}${teamId}&a=Index&c=VenueTeam&s=/Player/${obj.personId}`}>
          {obj.firstName.substring(0, 1)}. {obj.lastName}
        </a>{' '}
        {number < participants.length - 1 ? '/' : ''}
      </span>
    ));
  };

  return <>{renderParticipants()}</>;
};

const Status: React.FC<StatusProps> = ({ side, status }) => {
  if (status) {
    switch (status) {
      case 'RETIRED':
        if (side.didWin === false) {
          return (
            <div className={styles.flag}>
              <span className={styles.label}>
                <abbr title="Retired">RET</abbr>
              </span>
            </div>
          );
        } else {
          return (
            <div className={styles.winnerIcon}>
              <Tick />
            </div>
          );
        }
      case 'DEFAULT':
        if (side.didWin === false) {
          return (
            <div className={styles.flag}>
              <span className={styles.label}>
                <abbr title="Default">DEF</abbr>
              </span>
            </div>
          );
        } else {
          return (
            <div className={styles.winnerIcon}>
              <Tick />
            </div>
          );
        }

      case 'DEFAULTED':
        if (side.didWin === false) {
          return (
            <div className={styles.flag}>
              <span className={styles.label}>
                <abbr title="Default">DEF</abbr>
              </span>
            </div>
          );
        } else {
          return (
            <div className={styles.winnerIcon}>
              <Tick />
            </div>
          );
        }
      case 'INCOMPLETE':
        return (
          <div className={styles.flag}>
            <span className={styles.label}>
              <abbr title="Unfinished">UF</abbr>
            </span>
          </div>
        );
      case 'ABANDONED':
        return (
          <div className={styles.flag}>
            <span className={styles.label}>
              <abbr title="Unfinished">UF</abbr>
            </span>
          </div>
        );
      case 'CANCELLED':
        return (
          <div className={styles.flag}>
            <span className={styles.label}>
              <abbr title="Unfinished">UF</abbr>
            </span>
          </div>
        );
      case 'WALKOVER':
        if (side.didWin === false) {
          return (
            <div className={styles.flag}>
              <span className={styles.label}>
                <abbr title="Walkover">W/O</abbr>
              </span>
            </div>
          );
        } else {
          return (
            <div className={styles.winnerIcon}>
              <Tick />
            </div>
          );
        }

      case 'DOUBLE_WALKOVER':
        if (side.didWin === false) {
          return (
            <div className={styles.flag}>
              <span className={styles.label}>
                <abbr title="Walkover">W/O</abbr>
              </span>
            </div>
          );
        } else {
          return (
            <div className={styles.winnerIcon}>
              <Tick />
            </div>
          );
        }
    }
  }

  if (side.didWin === true) {
    return (
      <div className={styles.winnerIcon}>
        <Tick />
      </div>
    );
  }

  return <></>;
};

const Side: React.FC<SideProps> = ({ side, status, teamId }) => {
  return (
    <div className={`${styles.side} ${side.didWin === true && styles.winner}`}>
      <div className={styles.player}>
        <p>
          <span className={styles.name}>
            <Participants participants={side.participants} teamId={teamId} />
          </span>
          {side.teamAbbreviation !== null && (
            <span className={styles.team}>[{side.teamAbbreviation}]</span>
          )}
        </p>
      </div>

      <Status side={side} status={status} />

      {side.score !== null &&
        side.score.sets.map((obj: any, index: number) => (
          <div
            className={`${styles.score} ${index % 2 === 0 ? styles.even : styles.odd}`}
            key={index}
          >
            <p className={`${obj.didWin === true ? styles.winner : null}`}>
              {obj.tiebreakSet === true ? (
                <>[{obj.tiebreakScore}]</>
              ) : (
                <>
                  {obj.setScore} {obj.tiebreakScore !== '' ? <sup>{obj.tiebreakScore}</sup> : null}{' '}
                </>
              )}
            </p>
          </div>
        ))}
    </div>
  );
};

const TieMatchUp: React.FC<TieMatchUpProps> = ({
  data,
  number,
  homeTeamNumber,
  homeTeamId,
  awayTeamId
}) => {
  let displayNum = 1;
  if (number) {
    displayNum = number + 1;
  }

  let displayFormat = 'Doubles';
  if (data.type === 'SINGLES') {
    displayFormat = 'Singles';
  }

  let homeSide = data.side1;
  let awaySide = data.side2;

  if (homeTeamNumber === 2) {
    homeSide = data.side2;
    awaySide = data.side1;
  }

  return (
    <>
      <div className={styles.tieMatchUp}>
        <h3>
          #{displayNum} {displayFormat}
        </h3>
        <Side side={awaySide} status={data.status} teamId={awayTeamId} />
        <Side side={homeSide} status={data.status} teamId={homeTeamId} />
      </div>
    </>
  );
};

export default TieMatchUp;
